import React, { useState, useRef } from "react";
import "./BulkUpload.scss";
import ImportPreview from "../preview/preview";
import UploadSummaryModal from "./UploadSummaryModal";
import { POST_UPLOAD_CSV } from "../../../utils/api";
import axios from "axios";
import ToastMessage from "../../../utils/toasts/toastMessage";
import Loader from "../../../utils/loader/loader";
import { getCSVUploadedData } from "../../../Redux/Admin_Panel/people/people.action";
import { useDispatch } from "react-redux";
import CSVResponseTable from "./csvResponseTable";
import { apiRequest } from "../../../api/apiRequest";

const BulkUpload = ({ onCancel, onUploadComplete }) => {
  const dispatch = useDispatch();
  const [fileName, setFileName] = useState("No file chosen");
  const [fileData, setFileData] = useState(null);
  const [payloadfile, setPayloadFile] = useState(null);
  const [isPreview, setIsPreview] = useState(false);
  const [uploadedHeader, setUploadedHeader] = useState(null);
  const [showSummary, setShowSummary] = useState(false);
  const [toastState, setToastState] = useState({
    show: false,
    message: "",
    type: "",
  });
  const [loading, setLoading] = useState(false);

  const [latestUploadedData, setlatestUploadedData] = useState(null);
  const [isUploadOpen, setIsUploadOpen] = useState(true);

  const fileInputRef = useRef(null);

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    setPayloadFile(file);
    if (file) {
      setFileName(file.name);
      const reader = new FileReader();
      reader.onload = (event) => {
        const text = event.target.result;
        processData(text);
      };
      reader.readAsText(file);
    }
  };

  const processData = (csvText) => {
    // const lines = csvText.trim().split("\n");
    // const headers = lines[0].split(",").map((h) => h.trim());

    // const headerObject = { headers };
    // const valueObject = {
    //   values: lines.slice(1).map((line) => {
    //     // const cols = line.split(",").map((c) => c.trim());
    //     const cols = line.split(",").map((c) => c.trim());
    //     return headers.reduce((acc, key, i) => {
    //       acc[key] = cols[i] || "";
    //       return acc;
    //     }, {});
    //   }),
    // };

    const lines = csvText.trim().split(/\r?\n/);

const parseCSVLine = (line) => {
  return line
    .split(/,(?=(?:(?:[^"]*"){2})*[^"]*$)/)
    .map(col => col.trim().replace(/^"|"$/g, ""));
};

const headers = parseCSVLine(lines[0]);

const headerObject = { headers };

const valueObject = {
  values: lines.slice(1).map((line) => {
    const cols = parseCSVLine(line);

    return headers.reduce((acc, key, i) => {
      acc[key] = cols[i] || "";
      return acc;
    }, {});
  }),
};

    setFileData(valueObject.values);
    setUploadedHeader(headerObject.headers);
  };

  const triggerFileInput = () => {
    fileInputRef.current.click();
  };

  const handleUploadClick = () => {
    if (fileData && fileData.length > 0) {
      setIsPreview(true);
    } else {
      alert("Please select a valid CSV file first");
    }
  };

  // const handleFinalSuccess = async (settingsFromChild) => {
  //   if (!payloadfile) {
  //     setToastState({
  //       show: true,
  //       message: "Please select a file before uploading",
  //       type: "error",
  //     });
  //     return;
  //   }

  //   setLoading(true);

  //   const formData = new FormData();
  //   formData.append("file", payloadfile);

  //   try {
  //     const token = localStorage.getItem("access_token");

  //     const resp = await axios.post(POST_UPLOAD_CSV, formData, {
  //       headers: {
  //         Authorization: token ? `Bearer ${token}` : "",
  //       },
  //       withCredentials: true,
  //     });

  //     setToastState({
  //       show: true,
  //       message: "CSV file uploaded successfully.",
  //       type: "success",
  //     });
  //     dispatch(getCSVUploadedData());

  //     if (resp.status === 200) {
  //       // Pass uploaded data to parent for "User Summary" button
  //       if (onUploadComplete) onUploadComplete(resp?.data);

  //       setlatestUploadedData(resp?.data);
  //       setLoading(false);
  //       setIsPreview(false);
  //       setShowSummary(true);
  //     } else {
  //       setToastState({
  //         show: true,
  //         message: "error on upload!",
  //         type: "error",
  //       });
  //     }
  //   } catch (error) {
  //     setToastState({
  //       show: true,
  //       message: error.response.data.detail.message || "Uploading failed!",
  //       type: "error",
  //     });
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  const handleFinalSuccess = async (settingsFromChild) => {
  if (!payloadfile) {
    setToastState({
      show: true,
      message: "Please select a file before uploading",
      type: "error",
    });
    return;
  }

  setLoading(true);

  const formData = new FormData();
  formData.append("file", payloadfile);

  const result = await apiRequest("post", POST_UPLOAD_CSV, formData);

  setLoading(false);

  if (!result.success) {
    setToastState({
      show: true,
      message: result.message || "Uploading failed!",
      type: "error",
    });
    return;
  }

  setToastState({
    show: true,
    message: "CSV file uploaded successfully.",
    type: "success",
  });
  dispatch(getCSVUploadedData());

  // Pass uploaded data to parent for "User Summary" button
  if (onUploadComplete) onUploadComplete(result.data);

  setlatestUploadedData(result.data);
  setIsPreview(false);
  setShowSummary(true);
};

  const downloadCSV = () => {
    // Define CSV headers
    const headers = [
      "firstname",
      "lastname",
      "email",
      "role_name",
      "school",
      "class",
      "division",
      "account_status",
    ];

    // Convert headers to CSV format
    const csvContent = headers.join(",") + "\n";

    // Create a Blob
    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });

    // Create download link
    const link = document.createElement("a");
    const url = URL.createObjectURL(blob);

    link.setAttribute("href", url);
    link.setAttribute("download", "template.csv");
    link.style.visibility = "hidden";

    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };
  // Handle closing summary modal → return to dashboard
  const handleSummaryClose = () => {
    setShowSummary(false);
    onCancel();
  };

  return (
    <div className="bulk-upload-page-content">
      <div className="content-container-limited">
        <div className="top-nav-bar">
          <button
            className="back-link"
            // Agar loading chal rahi hai to back button disable kar sakte h
            onClick={
              loading ? null : isPreview ? () => setIsPreview(false) : onCancel
            }
            style={{
              opacity: loading ? 0.5 : 1,
              cursor: loading ? "not-allowed" : "pointer",
            }}
          >
            ← {isPreview ? "Back to Upload" : "Back to People"}
          </button>
        </div>

        {/* {!isPreview ? ( */}
        {!isPreview && !showSummary ? (
          <div className="upload-view-section">
            <div className="btn-container">
              <button className="download-btn" onClick={downloadCSV}>
                Download CSV Template
              </button>
            </div>
            <h2 className="page-title">
              Upload Users <span className="help-icon">?</span>
            </h2>

            <div className="upload-card">
              <div className="upload-header" onClick={() => setIsUploadOpen((v) => !v)} style={{ cursor: "pointer" }}>
                <span>Upload</span>
                <span className="toggle-icon">{isUploadOpen ? "▲" : "▼"}</span>
              </div>

              {isUploadOpen && <div className="upload-body">
                <div className="form-row-grid">
                  <div className="label-col-part">Example text file</div>
                  <div className="input-col-part">
                    <span className="file-name-display">{fileName}</span>
                  </div>
                </div>

                <div className="form-row-grid">
                  <div className="label-col-part">
                    Upload File {payloadfile === null && <span className="req-icon">!</span>}
                  </div>
                  <div className="input-col-part">
                    <div className="upload-zone-wrapper">
                      <input
                        type="file"
                        accept=".csv"
                        ref={fileInputRef}
                        onChange={handleFileChange}
                        style={{ display: "none" }}
                      />
                      <div
                        className="custom-file-input"
                        onClick={triggerFileInput}
                      >
                        <span className="placeholder-text">
                          {fileName === "No file chosen"
                            ? "Click to select a CSV file"
                            : fileName}
                        </span>
                        <button type="button" className="browse-btn">
                          Browse
                        </button>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="btn-footer">
                  <button
                    className="btn-upload-action"
                    onClick={handleUploadClick}
                  >
                    Upload
                  </button>
                </div>
              </div>}
            </div>
          </div>
        ) : showSummary ? (
          <CSVResponseTable
            data={latestUploadedData}
          />
        ) : (
          <div className="preview-view-section">
            {/* 3. Passing props to Child */}
            <ImportPreview
              onBack={() => setIsPreview(false)}
              onUploadSuccess={handleFinalSuccess}
              data={fileData}
              headerData={uploadedHeader}
              isLoading={loading}
            />
          </div>
        )}
      </div>
      <Loader show={loading} />
      <ToastMessage
        show={toastState.show}
        onClose={() => setToastState({ show: false, message: "", type: "" })}
        message={toastState.message}
        type={toastState.type}
      />

    </div>
  );
};

export default BulkUpload;
